export const COLOR_PRIMARY = "#00c999";
export const COLOR_SECONDARY = "#2F48EE";

export const BG_PRIMARY = "#111";
export const BG_SECONDARY = "#EFEEF6";
